import type Theme from '../../types/theme';
import { Measure, Unit } from '../../types/theme';
import { border, getBorderRadius, multiBorder } from './border';
import color from './color';
import { font } from './font';
import { getShadow } from './shadow';
import { getSizes } from './size';
import { utils } from './utils';

const transition = {
  standard: (firstProperty = 'all', ...restProperties: string[]) =>
    [firstProperty, ...restProperties]
      .map((property: string) => `${property} 0.2s cubic-bezier(0.4,0,0.4,1)`)
      .join(', '),
};

const IN_PIXELS = true;
const IN_REMS = false;

export const primaryPx: Theme = {
  border,
  borderRadius: getBorderRadius(IN_PIXELS),
  color,
  font,
  measure: Measure,
  multiBorder,
  shadow: getShadow(IN_PIXELS),
  size: getSizes(IN_PIXELS),
  transition,
  unit: Unit.PX,
  utils,
};

const primary: Theme = {
  border,
  borderRadius: getBorderRadius(IN_REMS),
  color,
  font,
  measure: Measure,
  multiBorder,
  shadow: getShadow(IN_REMS),
  size: getSizes(IN_REMS),
  transition,
  unit: Unit.REM,
  utils,
};

export default primary;
